import script from "./TextColorButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextColorButton.vue?vue&type=script&lang=ts&setup=true"

import "./TextColorButton.vue?vue&type=style&index=0&id=06492d64&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06492d64"]])

export default __exports__